import script from "./ProfileSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileSelector.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileSelector.vue?vue&type=style&index=0&id=17f3fb66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17f3fb66"]])

export default __exports__